import classNames from "classnames";
import { UseSelectPropGetters } from "downshift";
import React from "react";
import { MenuItem } from "../types";
import { CSS_CLASSES } from "./context-menu-css-classes";
import { ContextMenuItem, MenuItemRenderer } from "./context-menu-item";

export interface ContextMenuItemsListProps<M extends MenuItem> {
  menuItems: M[];
  highlightedIndex: number;
  getItemProps: UseSelectPropGetters<M>["getItemProps"];
  menuItemRenderer?: MenuItemRenderer;
  innerRef: React.Ref<HTMLUListElement>;
  style: React.CSSProperties;
  sizeStyle?: Partial<
    Pick<React.CSSProperties, "width" | "maxWidth" | "minWidth" | "height" | "maxHeight" | "minHeight">
  >;
  className?: string;
}

export const ContextMenuItemsList = <M extends MenuItem = MenuItem>({
  menuItems,
  highlightedIndex,
  getItemProps,
  menuItemRenderer,
  innerRef,
  sizeStyle,
  style,
  className,
}: ContextMenuItemsListProps<M>) => {
  const widthStyles: React.CSSProperties = sizeStyle || {
    maxWidth: 320,
    minWidth: 150,
    maxHeight: 200,
  };

  return (
    <ul
      ref={innerRef}
      style={{ ...style, ...widthStyles }}
      className={classNames(CSS_CLASSES.CONTEXT_MENU_LIST, className)}
    >
      {menuItems.map((menuItem, index) => (
        <li
          key={menuItem.label}
          {...getItemProps({ item: menuItem, index, role: "menuitem", disabled: menuItem.disabled })}
        >
          {menuItemRenderer ? (
            menuItemRenderer({ item: menuItem, index, highlighted: index === highlightedIndex })
          ) : (
            <ContextMenuItem item={menuItem} index={index} highlighted={index === highlightedIndex} />
          )}
        </li>
      ))}
    </ul>
  );
};
